import { Button, Typography } from "@mui/material";
import useColors from "../../api/hooks/useColors";
import SvgToIcon from "../../icons/SvgToIcon";
import { icons } from "../../scenes/stack/environment/icons/iconExport";

export default function ExportCSVButton({
  handleExport,
  disabled = false,
  ...props
}) {
  const colors = useColors();

  return (
    <Button
      sx={{
        background: colors.common_white,
        color: colors.action_active,

        border: `1px solid ${colors.enabled_stroke}`,
        borderRadius: "8px",
        textTransform: "none",
        whiteSpace: "nowrap",
        "&:hover": {
          background: colors.grey_8percent,
        },
        ...props.sx,
      }}
      onClick={handleExport}
      disabled={disabled}
      startIcon={
        <SvgToIcon
          IconLogo={icons.ExportCSVIcon}
          style={{ width: "18px", color: "transparent" }}
        />
      }
    >
      <Typography
        variant="overline"
        sx={{
          color: colors.text_secondary,
        }}
      >
        {"Export to CSV"}
      </Typography>
    </Button>
  );
}
